import dayjs from 'dayjs';

export const CADENCES = ['Daily', 'Weekly', 'Monthly', 'Monthly - MTD', 'Quarterly', 'Yearly', 'Yearly - YTD'];
export const COMPARISONS: Record<string, Array<string>> = {
  Daily: ['DoD Day Prior'],
  Weekly: ['WoW Week Prior'],
  Monthly: ['MoM Last Month', 'MoM Same Month LY'],
  'Monthly - MTD': ['MoM MTD Last Month'],
  Quarterly: ['QoQ Last Quarter', 'QoQ Same Quarter LY'],
  Yearly: ['YoY Last Year'],
  'Yearly - YTD': ['YoY YTD Last Year'],
};
const iso = (date: dayjs.Dayjs) => date.format('YYYY-MM-DD');
export function selectedWindow(selected: string, cadence: string): { from: string; to: string } {
  const date = dayjs(selected);
  let from = date,
    to = date;
  if (cadence === 'Weekly') {
    from = date.subtract((date.day() + 6) % 7, 'day');
    to = from.add(6, 'day');
  }
  if (cadence === 'Monthly') {
    from = date.startOf('month');
    to = date.endOf('month');
  }
  if (cadence === 'Monthly - MTD') from = date.startOf('month');
  if (cadence === 'Quarterly') {
    from = date.month(Math.floor(date.month() / 3) * 3).startOf('month');
    to = from.add(3, 'month').subtract(1, 'day');
  }
  if (cadence === 'Yearly') {
    from = date.startOf('year');
    to = date.endOf('year');
  }
  if (cadence === 'Yearly - YTD') from = date.startOf('year');
  return { from: iso(from), to: iso(to) };
}
export function selectionPrior(selected: string, cadence: string, comparison: string) {
  const date = dayjs(selected);
  const prior =
    comparison === 'DoD Day Prior'
      ? date.subtract(1, 'day')
      : comparison === 'WoW Week Prior'
        ? date.subtract(7, 'day')
        : /LY|Last Year/.test(comparison)
          ? date.subtract(1, 'year')
          : comparison === 'QoQ Last Quarter'
            ? date.subtract(3, 'month')
            : date.subtract(1, 'month');
  return selectedWindow(iso(prior), cadence);
}
/** Workbook custom periods shift the start, then preserve the current inclusive day count. */
export function customPrior(from: string, to: string, comparison: string) {
  const first = dayjs(from),
    length = dayjs(to).diff(first, 'day');
  const start =
    comparison === 'previous'
      ? first.subtract(length + 1, 'day')
      : comparison === 'month'
        ? first.subtract(1, 'month')
        : comparison === 'quarter'
          ? first.subtract(3, 'month')
          : comparison === '28days'
            ? first.subtract(28, 'day')
            : first.subtract(1, 'year');
  return { from: iso(start), to: iso(comparison === '28days' ? first.subtract(1, 'day') : start.add(length, 'day')) };
}
